export function areArraysEqualDeep(arr1: any[], arr2: any[]): boolean {
    if (arr1?.length !== arr2?.length) {
        return false;
    }
    return arr1.every((item, index) => {
        return JSON.stringify(item) === JSON.stringify(arr2[index]);
    });
}

export function toBase64(file: File) {
    return new Promise((resolve, reject): void => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (): void => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

export function mergeDeep(target: any, source: any): any {
    Object.keys(source).forEach(key => {
        const sourceValue = source[key];
        const targetValue = target[key];

        if (Array.isArray(sourceValue)) {
            target[key] = mergeArrayById(targetValue || [], sourceValue);
        } else if (sourceValue && typeof sourceValue === 'object') {
            target[key] = mergeDeep(targetValue ? targetValue : {}, sourceValue);
        } else {
            target[key] = sourceValue;
        }
    });

    return target;
}

export function mergeArrayById(targetArray: any[], sourceArray: any[]): any[] {
    const mergedArray = [...targetArray];

    sourceArray.forEach(sourceObj => {
        const targetIndex: number = mergedArray.findIndex(targetObj => targetObj.id === sourceObj.id);

        if (targetIndex >= 0) {
            mergedArray[targetIndex] = mergeDeep(mergedArray[targetIndex], sourceObj);
        } else {
            mergedArray.push(sourceObj);
        }
    });

    return mergedArray;
}
